import React from "react";
import CountUp from "react-countup";
import { motion } from "framer-motion";
import "../css/Dashboard.css";

export default function ActivityOverview({ loading, error, data }) {
  if (loading)
    return (
      <div className="activity-overview-card">
        <p>Loading...</p>
      </div>
    );

  if (error)
    return (
      <div className="activity-overview-card">
        <p className="error">{error}</p>
      </div>
    );

  if (!data) return null;

  const listItems = [
    { label: "Total Customers", value: data.total_customers || 0 },
    { label: "Total Service Providers", value: data.total_service_providers || 0 },
    { label: "Total Subscribed Users", value: data.total_subscribed_users || 0 },
    { label: "Total Unsubscribed Users", value: data.total_unsubscribed_users || 0 },
  ];

  return (
    <motion.div
      className="activity-overview-card"
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
    >
      <h3 className="activity-overview-title">Activity Overview</h3>
      <ul className="activity-overview-list">
        {listItems.map((item, index) => (
          <motion.li
            key={index}
            initial={{ opacity: 0, y: 15 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 * index, duration: 0.5 }}
          >
            <span>{item.label}</span>
            <strong>
              <CountUp
                end={item.value}
                duration={2}
                separator=","
                enableScrollSpy={true}
                scrollSpyOnce={true}
              />
            </strong>
          </motion.li>
        ))}
      </ul>
    </motion.div>
  );
}
